import React from "react";
import { connect } from "react-redux";
import "../../Grid/grid.css";
import "./TranScriptChat.css";
import { selectIsPLGAccount } from "../../../store/userSelectors";

class ViewNotes extends React.Component {
    deleteNode = (id) => {
        this.props.deleteNotes(id);
    }

    getNoteDisplayName = (item) => {
        if (item?.name) {
            return item.name;
        }
        if (item?.user_name) {
            return item.user_name;
        }
        if (item?.author_name) {
            return item.author_name;
        }
        return this.props.comapny || '';
    }

    rederNotes = () => {
        const chatlogo = this.props.chatlogo || '';
        return this.props.data.map((item) =>
            <div key={item.id} className={`notes${this.props.isPLG ? ' notes--no-logo' : ''}`}>
                {!this.props.isPLG && chatlogo && (
                    <img src={chatlogo} alt={this.props.comapny || ''} className="mr-2"/>
                )}
                <div className="notesDesctiption">
                    <div className="companyNameDate">
                        <span className="name mr-2">{this.getNoteDisplayName(item)}</span>
                        <span className="date mr-2">{item.created_at}</span>
                        <span className="deleteIcon text-danger" onClick={() => this.deleteNode(item.id)}><i className="fa fa-trash"></i></span>
                    </div>
                    <div className="innernotes pr-2">{item.comment}</div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div>
                <div className="ui loading form chatstatusloadingdiv" style={{display:"none"}}></div>
                {this.props.data && this.rederNotes()}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    isPLG: selectIsPLGAccount(state),
});

export default connect(mapStateToProps)(ViewNotes);
